// The end-of-trip endpoints for this panel (Booking Flow v2). The trip modals are the same file in the
// admin and staff panels; only this map differs.
const tripUrls = {
    close: (bookingId) => `/staff/trip/close/${bookingId}`,
    completePreview: (bookingId) => `/staff/trip/complete/preview/${bookingId}`,
    complete: (bookingId) => `/staff/trip/complete/${bookingId}`,
    endTime: (bookingId) => `/staff/trip/end-time/${bookingId}`,
    damage: (bookingId) => `/staff/trip/damage/${bookingId}`,
    finesPreview: (bookingId) => `/staff/trip/inspect/preview/${bookingId}`,
    fines: (bookingId) => `/staff/trip/inspect/${bookingId}`,
    swap: (bookingId) => `/staff/trip/swap/${bookingId}`,
    availableCars: "/staff/flow/available-cars",
    pendingVerify: (bookingId) => `/staff/trip/pending/verify/${bookingId}`,
};

export default tripUrls;
